import { isNullOrUndef, isNumber } from './validations';
export default function dateToEpochSeconds(date) {
    if (isNullOrUndef(date)) {
        // @ts-ignore - maybe throw error?
        return null;
    }
    // Hacky test to see if epoch seconds
    if (isNumber(date) && Math.floor(Math.log10(date)) === 9) {
        return date;
    }
    return Math.ceil(new Date(date).getTime() / 1000);
}
